export default "__VITE_ASSET__Bvt3DV0V__"